import request from '@/utils/request'
import onlyNasFileUploadUseRequest from '@/utils/onlyNasFileUploadUseRequest'
import store from '@/store'
// import { stat } from 'fs'

export function editProfile (data) {
  return request({
    url: '/api/teachInfo/EditProfile',
    method: 'post',
    data
  })
}
// 个人信息编辑1
export function EditPersonalInformation (formData) {
  return onlyNasFileUploadUseRequest({
    timeout: 3 * 60 * 1000,
    url: '/api/teachInfo/EditPersonalInformation',
    method: 'post',
    data: formData
  })
}
// 个人信息编辑2
export function EditEducationExperience (data) {
  return onlyNasFileUploadUseRequest({
    timeout: 3 * 60 * 1000,
    url: '/api/teachInfo/EditEducationExperience',
    method: 'post',
    data
  })
}
// 个人信息编辑3
export function EditWorkExperience (data) {
  console.log(store.getters.nasFileHost)
  return onlyNasFileUploadUseRequest({
    timeout: 3 * 60 * 1000,
    url: `/api/teachInfo/EditWorkExperience`,
    method: 'post',
    data
  })
}

// 单独添加SkypeId
export function addSkypeId (data) {
  return request({
    url: `/api/teachInfo/EditTeachInfo`,
    method: 'post',
    data
  })
}

// 20191225 新增上传视频
export function UpLoadLifeVideo (data) {
  return onlyNasFileUploadUseRequest({
    timeout: 10 * 60 * 1000,
    url: `/api/teachInfo/UpLoadLifeVideo`,
    method: 'post',
    data
  })
}


// 20200114 新增上传视频分块
export function UpLoadLifeVideoChunk (data) {
 
  return onlyNasFileUploadUseRequest({
    timeout: 10 * 60 * 1000,
    url: `/api/teachInfo/ChunkSave`,
    method: 'post',
    data
  })
}

// 20200114 新增上传视频分块完成后，合并分块请求
export function UpLoadLifeVideoMerge (data) {
  console.log("UpLoadLifeVideoFileMerge");
  return onlyNasFileUploadUseRequest({
    timeout: 10 * 60 * 1000,
    url: `/api/teachInfo/FileMerge`,
    method: 'post',
    data
  })
}
export function ChunkCancel (fileCode) {
  return onlyNasFileUploadUseRequest({
    timeout: 10 * 60 * 1000,
    url: `/api/teachInfo/ChunkCancel?fileCode=${fileCode}`,
    method: 'post'
  })
}

// 20191225 新增上传生活照 2－6张
export function UpLoadLifePhoto (data) {
  return onlyNasFileUploadUseRequest({
    timeout: 3 * 60 * 1000,
    url: `/api/teachInfo/UpLoadLifePhoto`,
    method: 'post',
    data
  })
}
// 单独上传录音/单独上传头像
export function uploadVoiceAvatar (data) {
  return onlyNasFileUploadUseRequest({
    timeout: 10 * 60 * 1000,
    url: `/api/TeachInfo/UploadVoiceAvatar`,
    method: 'post',
    data
  })
}
// 20210514 新增上传证件照
export function uploadProfessionalIdPhoto (data) {
  return onlyNasFileUploadUseRequest({
    timeout: 10 * 60 * 1000,
    url: `/api/TeachInfo/UploadProfessionalIdPhoto`,
    method: 'post',
    data
  })
}

// 20240530 新增上传老师ai形象照
export function upLoadVirtualProfessionalPhoto (data) {
  return onlyNasFileUploadUseRequest({
    timeout: 10 * 60 * 1000,
    url: `/api/TeachInfo/UpLoadVirtualProfessionalPhoto`,
    method: 'post',
    data
  })
}

export function getLocations (parentId) {
  return request({
    url: '/api/teachInfo/Locations',
    method: 'post',
    data: { 'parentId': parentId }
  })
}
export function getSchools () {
  return request({
    url: '/api/teachInfo/Schools',
    method: 'post'
  })
}
export function getHobbies () {
  return request({
    url: '/api/teachInfo/Hobbies',
    method: 'post'
  })
}
export function editHobbies (data) {
  return request({
    url: '/api/teachInfo/EditHobbies',
    method: 'post',
    data
  })
}
// TeachAcUseRecord
export function getTeachAcUseRecord (pageIndex, pageSize) {
  return request({
    url: '/api/teachInfo/TeachAcUseRecord',
    method: 'post',
    data: { pageIndex, pageSize }
  })
}
// TeachAcRecord
export function getTeachAcRecord (pageIndex, pageSize) {
  return request({
    url: '/api/teachInfo/TeachAcRecord',
    method: 'post',
    data: { pageIndex, pageSize }
  })
}
export function getTeachReferrals (pageIndex, pageSize) {
  return request({
    url: '/api/teachInfo/TeachReferrals',
    timeout: 2 * 60 * 1000,
    method: 'post',
    data: {
      pageIndex, pageSize
    }
  })
}
// TutorApply
export function addTutorApply (firstName, lastName, email, skypeId, mobileNumber, country) {
  return request({
    url: '/api/teachInfo/TutorApply',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: {
      FirstName: firstName,
      LastName: lastName,
      Email: email,
      SkyID: skypeId,
      MobileNumber: mobileNumber,
      Country: country,
      TutorSource: 12
    }
  })
}
// ExchangeCash
export function exchangeCash (flowersCount, remark) {
  return request({
    url: '/api/teachInfo/ExchangeCash',
    method: 'post',
    data: {
      flowersCount: flowersCount,
      remark: remark
    }
  })
}
// Photo
export function uploadAvator (formData) {
  return onlyNasFileUploadUseRequest({
    timeout: 0,
    url: '/api/teachInfo/Photo',
    method: 'post',
    data: formData
  })
}
// VoiceRecording
export function uploadVoiceRecording (formData) {
  return onlyNasFileUploadUseRequest({
    timeout: 0,
    url: `${store.getters.nasFileHost}/api/teachInfo/VoiceRecording`,
    method: 'post',
    data: formData
  })
}
// PersonalCertificates
export function uploadCertificates (formData) {
  return onlyNasFileUploadUseRequest({
    timeout: 0,
    url: '/api/teachInfo/PersonalCertificates',
    method: 'post',
    data: formData
  })
}
// Identity
export function identity (formData) {
  return onlyNasFileUploadUseRequest({
    timeout: 0,
    url: '/api/teachInfo/Identity',
    method: 'post',
    data: formData
  })
}
// TrackLog
export function getTrackLog (applyId) {
  return request({
    url: '/api/teachInfo/TrackLog',
    method: 'post',
    data: { applyId }
  })
}

// TutorBookClas
export function getTutorBookClass (pageIndex, pageSize, isCheck, status) {
  return request({
    url: '/api/teachInfo/TutorBookClass',
    method: 'post',
    data: {
      pageIndex: pageIndex,
      pageSize: pageSize,
      isCheck: isCheck,
      status: status
    }
  })
}
export function trainerAbsent (classId) {
  return request({
    url: `/api/teachInfo/TrainerAbsent?classId=${classId}`,
    method: 'post'
  })
}
export function updateTrainClassStatus (id,comment) {
  return request({
    url: '/api/teachInfo/TrainClassStatus',
    method: 'post',
    data: {
      id: id,
      comment
    }
  })
}

export function updateTrainComment (id, comment) {
  return request({
    url: '/api/teachInfo/TrainComment',
    method: 'post',
    data: {
      id: id,
      comment: comment
    }
  })
}
// TrainCourseLesson
export function getTrainCourseLesson (id) {
  return request({
    url: '/api/teachInfo/TrainCourseLesson',
    method: 'post',
    data: {
      id: id
    }
  })
}
// TraineeRemark
export function traineeRemark (id, remark) {
  return request({
    url: '/api/teachInfo/TraineeRemark',
    method: 'post',
    data: {
      id, remark
    }
  })
}
// StuComments
export function getStuComments (pageIndex, pageSize) {
  return request({
    timeout: 0,
    url: '/api/tutorcomm/StuComments',
    method: 'post',
    data: {
      pageIndex: pageIndex,
      pageSize: pageSize
    }
  })
}
// TutorRanking
export function getTutorRankings () {
  return request({
    url: '/api/teachInfo/TutorRanking',
    method: 'post',
    data: {
    }
  })
}

// UserCertInfo
export function getUserCertInfo () {
  return request({
    url: '/api/teachInfo/UserCertInfo',
    method: 'post',
    data: {

    }
  })
}

// MaterialTrainerInfo
export function getMaterialTrainerInfo (timeFlag) {
  return request({
    url: '/api/teachInfo/MaterialTrainerInfo?timeFlag=' + timeFlag,
    method: 'post',
    data: {
    }
  })
}

// TrainBookClassByType
export function trainBookClassByType (classType, classTime, classTimeEnd, VideoLink) {
  return request({
    url: '/api/teachInfo/TrainBookClassByType',
    method: 'post',
    data: {
      classType, classTime, classTimeEnd, VideoLink
    }
  })
}

export function getTeacherInfo () {
  return request({
    url: '/api/teachInfo/TeacherInfo',
    method: 'post'
  })
}

export function editTeachSchool (data) {
  return request({
    url: '/api/teachInfo/EditTeachSchool?schoolName=' + data,
    method: 'post'
  })
}

export function editTeachLocation (parentId, locatoinName) {
  return request({
    url: `/api/teachInfo/EditTeachLocation?parentId=${parentId}&locatoinName=${locatoinName}`,
    method: 'post'
  })
}
export function bindTutorPhone (phone, verificationCode, countryCode) {
  return request({
    url: `/api/teachInfo/BindTutorPhone`,
    method: 'post',
    data: {
      phone, verificationCode, countryCode
    }
  })
}
export function sendVerificationCode (phone, countryCode) {
  return request({
    url: `/api/teachInfo/SendVerificationCode`,
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: {
      countryCode, phone
    }
  })
}
export function remindMeLater () {
  return request({
    url: `/api/teachInfo/RemindMeLater`,
    method: 'post'
  })
}
// 是否显示合同签署入口
export function showContract () {
  return request({
    url: `/api/tutorcomm/ShowContract`,
    method: 'post'
  })
}

// 保存合同数据
export function saveContractInfo (data) {
  return request({
    url: `/api/tutorcomm/SaveContractInfo`,
    method: 'post',
    timeout: 5 * 60 * 1000,
    data: data
  })
}

// 获取合同数据
export function getContractInfo (isCustomized) {
  return request({
    url: `/api/tutorcomm/GetContractInfo?isCustomized=${isCustomized}`,
    method: 'post'
  })
}

// 获取认证照片
export function getTutorAuditInfo () {
  return request({
    url: `/api/tutorcomm/GetTutorAuditInfo`,
    method: 'post'
  })
}
// 校检短信验证码
export function signContractVerifyCode (phone, verificationCode, countryCode) {
  return request({
    url: `/api/TutorComm/SignContractVerifyCode`,
    timeout: 3 * 60 * 1000,
    method: 'post',
    data: {
      phone, verificationCode, countryCode
    }
  })
}

// 已验证的手机号码信息
export function getSignPhoneInfo () {
  return request({
    url: `/api/TutorComm/SignPhoneInfo`,
    method: 'post'
  })
}

// 接入自主约面系统 TutorComm/GetReferralLink
export function getReferralLink () {
  return request({
    url: `/api/TutorComm/GetReferralLink`,
    method: 'post'
  })
}

export function getPersonalInformation () {
    return request({
      url: `/api/TeachInfo/PersonalInformation`,
      method: 'post'
    })
  }

export function getEducationExperience () {
    return request({
        url: `/api/TeachInfo/EducationExperience`,
        method: 'post'
    })
}

export function getWorkExperience () {
    return request({
        url: `/api/TeachInfo/WorkExperience`,
        method: 'post'
    })
}

export function getLifeShowInfo () {
    return request({
        url: `/api/TeachInfo/LifeShowInfo`,
        method: 'post'
    })
}
// 老师请假列表
export function getTutorLeaveList (pageIndex,pageSize) {
  return request({
      url: `/api/TutorComm/GetTutorLeaveList?pageIndex=${pageIndex}&pageSize=${pageSize}`,
      method: 'post'
  })
}
// 老师添加请假
export function addTutorLeave (data) {
  return request({
      url: `/api/TutorComm/AddTutorLeave`,
      method: 'post',
      data:data
  })
}
// 修改老师请假 请假/销假
export function editTutorLeave (data) {
  return request({
      url: `/api/TutorComm/EditTutorLeave`,
      method: 'post',
      data:data
  })
}
// 撤销请假
export function undoTutorLeave (id) {
  return request({
      url: `/api/TutorComm/UndoTutorLeave?id=${id}`,
      method: 'post'
  })
}
// 老师上课黄赌毒风险项目
export function getIsAgreeProtocol () {
  return request({
      url: `/api/TutorComm/GetIsAgreeProtocol`,
      method: 'post'
  })
}
export function agreeProtocolByTuid () {
  return request({
      url: `/api/TutorComm/AgreeProtocolByTuid`,
      method: 'post'
  })
}
// 老师新标签 
export function getTutorBiAspectDataList () {
  return request({
      url: `/api/TutorComm/GetTutorBiAspectDataList`,
      method: 'post'
  })
}
// 获取老师是否提交过新标签，及选中的标签Id
export function getTeacherSelectedTags () {
  return request({
      url: `/api/TutorComm/GetTeacherSelectedTags`,
      method: 'post'
  })
}
// 提交选中的新标签
export function submitSelectedTutorBiAspectTags (SelectedTagIds) {
  return request({
      url: `/api/TutorComm/SubmitSelectedTutorBiAspectTags`,
      method: 'post',
      data:{
        SelectedTagIds
      }
  })
}
// 当前老师是否是新标签实验老师
export function isBiAspectTeacher (userid) {
  return request({
      url: `/api/TutorComm/IsBiAspectTeacher?userid=${userid}`,
      method: 'post'
  })
}
// 进入Aclassroom链接 
export function getAClassRoomWebLink (type,isclient,roomNumber,trainingSubTypeName) {
  return request({
      url: `/api/TeachInfo/GetAClassRoomWebLink?type=${type}&trainingSubTypeName=${trainingSubTypeName}&isclient=${isclient}&roomNumber=${roomNumber}`,
      method: 'post'
  })
}
// 国际老师不同意/同意新的合同内容
// export function isAgreenProtocolByInternational (type) {
//   return request({
//       url: `/api/TutorComm/IsAgreenProtocolByInternational?type=${type}`,
//       method: 'post'
//   })
// }
// 
// export function isShowProtocolByInternational () {
//   return request({
//       url: `/api/TutorComm/IsShowProtocolByInternational`,
//       method: 'post'
//   })
// }

// 获取老师是国际还是定制
export function getTutorSubjectType () {
  return request({
      url: `/api/TutorComm/GetTutorSubjectType`,
      method: 'post'
  })
}
// 20210226合同更新弹框
export function getIsShowPopoutByContract () {
  return request({
      url: `/api/TutorComm/GetIsShowPopoutByContract `,
      method: 'post'
  })
}
//不同意/同意新的合同内容
export function agreenPopoutByContract (isAgreen) {
  return request({
      url: `/api/TutorComm/AgreenPopoutByContract?isAgreen=${isAgreen}`,
      method: 'post'
  })
}


export function getTeachingExperience () {//教师工作经历
  return request({
      url: `/api/TeachInfo/TeachingExperience`,
      method: 'post'
  })
}

export function editTeachingExperience (data) {
  return onlyNasFileUploadUseRequest({
    timeout: 3 * 60 * 1000,
    url: `/api/teachInfo/EditTeachingExperience`,
    method: 'post',
    data
  })
}

// 是否公开课老师
export function getIsOpenClassTeacher () {
  return request({
      url: `/api/TutorComm/GetIsOpenClassTeacher`,
      method: 'post'
  })
}
// 获取公开课教室地址-直接进入教室
export function getOpenClassWebLink (classId) {
  return request({
      url: `/api/TutorComm/GetOpenClassWebLink?classId=${classId}`,
      method: 'post'
  })
}
// 记录老师客户端使用情况
export function AddTutorClientUsageLog () {
  return request({
      url: `/api/TutorComm/AddTutorClientUsageLog`,
      method: 'post'
  })
}

// 获取好评数据
export function getStuCommentViewInfo (startTime, endTime, level) {
  return request({
      url: `/api/TutorComm/GetStuCommentViewInfo`,
      method: 'post',
      data: {
        startTime,
        endTime,
        level
      }
  })
}

//获取tesol信息 及 是否需要弹层
export function getTESOLInformationReview(){
  return request({
    url: '/api/TeachInfo/GetTESOLInformationReview',
    method: 'post'
  })
}

//保存tesol信息
export function saveTESOLInformation(formData){
  return onlyNasFileUploadUseRequest({
    timeout: 3 * 60 * 1000,
    url: '/api/TeachInfo/SaveTESOLInformation',
    method: 'post',
    data: formData
  })
}
// 客户端临时教室入口
export function getTemporaryClassroomWebLink () {
  return request({
      url: `/api/TutorComm/GetTemporaryClassroomWebLink`,
      method: 'post'
  })
}
// 老师端迁移通知
export function isShowTutorSystemTransferNotice () {
  return request({
      url: `/api/TutorComm/IsShowTutorSystemTransferNotice`,
      method: 'post'
  })
}

// 老师端提示skype填写弹层
export function isShowDialogList () {
  return request({
      url: `/api/TutorComm/ShowDialogList`,
      method: 'post'
  })
}

// 删除教师资格证或无犯罪证明
export function deleteCertificate (type) {
  return request({
      url: `/api/TeachInfo/DeleteCertificate?type=${type}`,
      method: 'post'
  })
}

// 老师端公告栏banner
export function getTutorHomeBanner () {
  return request({
      url: `/api/TeachInfo/GetTutorHomeBanner`,
      method: 'post'
  })
}

//公开课列表 
export function getOpenClassTable (data) {
  return request({
      url: `/api/TutorComm/GetOpenClassTable`,
      method: 'post',
      data: data
  })
}

//记录客户端版本信息
export function AddPCClientVersionInfoRecord(version,clientName){
  return request({
    url: `/api/TutorComm/AddPCClientVersionInfoRecord?version=${version}&clientName=${clientName}`,
    method: 'post'
  })
}

//声网上报老师客户端版本号
export function UpdateUserVersion(data){
  return request({
    url: `/api/ClassTable/UpdateUserVersion`,
    method: 'post',
    data: data
  })
}

//MyReferrals
export function MyReferralsInfo(startTime, endTime){
  return request({
    url: `/api/Referrals/ReferralInfo?beginDate=`+startTime+"&endDate="+endTime,
    method: 'post',
  })
}

// 转介绍列表
export function MyReferralsList(PageIndex, PageSize){
  return request({
    url: `/api/Referrals/TeachReferralsV2?PageIndex=${PageIndex}&PageSize=${PageSize}`,
    method: 'post',
  })
}

// 转介绍列表/个人信息
export function MyReferralsPersonal(applyId){
  return request({
    url: `/api/Referrals/ReferralTutorInfo?applyId=`+applyId,
    method: 'post',
  })
}

// 转介绍等级记录
export function MyReferralsLevel(applyId){
  return request({
    url: `/api/Referrals/ReferralTutorLevelRecord?applyId=`+applyId,
    method: 'post',
  })
}

// 转介绍奖金发放记录
export function MyReferralsBounds(applyId,PageIndex, PageSize){
  return request({
    url: `/api/Referrals/ReferralBoundsList?applyId=`+applyId+"&PageIndex="+PageIndex+"&PageSize="+PageSize,
    method: 'post',
  })
}

// 转介绍团队
export function MyReferralsTeam(applyId,PageIndex, PageSize){
  return request({
    url: `/api/Referrals/ReferralTeam?applyId=`+applyId+"&PageIndex="+PageIndex+"&PageSize="+PageSize,
    method: 'post',
  })
}

// 转介绍开课进度
export function MyReferralsClass(applyId){
  return request({
    url: `/api/Referrals/TrackLogV2?applyId=`+applyId,
    method: 'post',
  })
}

// 转介绍新旧判断
export function MyReferralsOld(){
  return request({
    url: `/api/Referrals/ReferralVerson`,
    method: 'post',
  })
}
// 连续缺席
export function getTutorAbsentMsgNew () {
  return request({
    url: '/api/Message/GetTutorAbsentMsgNew',
    method: 'post'
  })
}
// 
export function userExtInfo () {
  return request({
    url: '/api/Account/UserExtInfo',
    method: 'post'
  })
}

export function sendEmailVerificationCode () {
  return request({
    url: `/api/teachInfo/SendVerificationCodeByEmail`,
    method: 'post',
    timeout: 3 * 60 * 1000
  })
}

// 校检邮箱验证码
export function signContractEmailVerifyCode (EmailCode) {
  return request({
    url: `/api/TutorComm/SignContractVerifyCodeByEmail`,
    timeout: 3 * 60 * 1000,
    method: 'post',
    data: {
      EmailCode
    }
  })
}